import { combineReducers } from "@reduxjs/toolkit";

import { login, appData } from "@/features/auth";
import { account, setting } from "@/features/admin";
import post from "./post";
import postComment from "./postComment";
import chat from "./chat";
import { event } from "@/features/user";
import { advert } from "@/features/merchant";
import { api } from "@/services/api";

import { progress, response } from "./common";

const combinedReducers = combineReducers({
  login,
  account,
  setting,
  chat,
  post,
  postComment,
  progress,
  response,
  appData,
  advert,
  event,
  [api.reducerPath]: api.reducer,
});

export type RootState = ReturnType<typeof combinedReducers>;

export default combinedReducers;
